
<div style="display: flex;justify-content: center;margin-top: 30px">
    <div class="container1" style="width: 85%">
      <h2 >Reporte de equipos asignados</h2>
      <div *ngIf="!loading" class="divButtons" style="justify-content: flex-start">
  
        <mat-form-field appearance="fill" class="buttonFilter">
          <mat-label>MARCA</mat-label>
          <mat-select [(value)]="selectMarca" (selectionChange)="applyFilterSelect()">
            <mat-option value={{null}}>No seleccionar</mat-option>
            <mat-option *ngFor="let marca of arrayMarcas" value={{marca}}>{{marca}}</mat-option>
          </mat-select>
        </mat-form-field>
  
  
        <mat-form-field appearance="fill" class="buttonFilter">
          <mat-label>MODELO</mat-label>
          <mat-select [(value)]="selectModelo" (selectionChange)="applyFilterSelect()">
            <mat-option value={{null}}>No seleccionar</mat-option>
            <mat-option *ngFor="let modelo of arrayModelos" value={{modelo}}>{{modelo}}</mat-option>
          </mat-select>
        </mat-form-field>
  
        <mat-form-field appearance="fill" class="buttonFilter">
          <mat-label>TALLA</mat-label>
          <mat-select [(value)]="selectTalla" (selectionChange)="applyFilterSelect()">
            <mat-option value={{null}}>No seleccionar</mat-option>
            <mat-option *ngFor="let talla of arrayTallas" value={{talla}}>{{talla}}</mat-option>
          </mat-select>
        </mat-form-field>
  
        <mat-form-field appearance="fill" class="buttonFilter">
          <mat-label>CATEGORÍA</mat-label>
          <mat-select [(value)]="selectCategoria" (selectionChange)="applyFilterSelect()">
            <mat-option value={{null}}>No seleccionar</mat-option>
            <mat-option *ngFor="let categoria of arrayCategorias" value={{categoria}}>{{categoria}}</mat-option>
          </mat-select>
        </mat-form-field>
  
        <mat-form-field appearance="fill" class="buttonFilter">
          <mat-label>FILE</mat-label>
          <mat-select [(value)]="selectFile" (selectionChange)="applyFilterSelect()">
            <mat-option value={{null}}>No seleccionar</mat-option>
            <mat-option *ngFor="let file of arrayFiles" value={{file}}>{{file}}</mat-option>
          </mat-select>
        </mat-form-field>
  
        <mat-form-field appearance="fill" class="buttonFilterFecha" >

            <mat-label>FECHA FILE</mat-label>
      
            <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
      
            <mat-date-range-input [rangePicker]="rangePicker" >
              <input matStartDate placeholder="Inicio" [(ngModel)]="startDate">
              <input matEndDate placeholder="Fin"   [(ngModel)]="endDate">
            </mat-date-range-input>
      
            <mat-date-range-picker #rangePicker>
              <mat-date-range-picker-actions>
                <button mat-button matDateRangePickerCancel>Cancel</button>
                <button style="background-color: rgb(184, 69, 18);color: white;" mat-raised-button (click)="applyFilterSelect()" matDateRangePickerApply>Filtrar</button>
      
                <button  mat-button matDateRangePickerCancel (click)="cleanDateSelected()">Limpiar</button>
              </mat-date-range-picker-actions>
            </mat-date-range-picker>
      
          </mat-form-field>
        
      </div>
  
      <div *ngIf="!loading" style="display: flex;justify-content: center;margin-top: 1rem">
        <mat-form-field appearance="outline" class="divInputSearch">
          <mat-label>Filtrar</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar Búsqueda"/>
        </mat-form-field>
      </div>
  
      <div *ngIf="loading" class="spinner" >
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      </div>
  
  
        <div *ngIf="!loading" class="mat-elevation-z8 overflow">
          <table mat-table [dataSource]="dataSource">
  
            <ng-container matColumnDef="nombre" >
              <th mat-header-cell *matHeaderCellDef>Nombre</th>
              <td mat-cell *matCellDef="let element">{{ element.equipoInfo.nombreEquipo }}</td>
            </ng-container>
  
            <ng-container matColumnDef="marca" >
              <th mat-header-cell *matHeaderCellDef>Marca</th>
              <td mat-cell *matCellDef="let element">{{ element.equipoInfo.marcaEquipo }}</td>
            </ng-container>
  
            <ng-container matColumnDef="modelo" >
              <th mat-header-cell *matHeaderCellDef>Modelo</th>
              <td mat-cell *matCellDef="let element">{{ element.equipoInfo.modeloEquipo }}</td>
            </ng-container>
  
            <ng-container matColumnDef="categoria">
              <th mat-header-cell *matHeaderCellDef>Categoria</th>
              <td style="max-width: 40px" mat-cell *matCellDef="let element">{{ element.equipoInfo.categoria }}</td>
            </ng-container>

  
            <ng-container matColumnDef="fileNumber" >
              <th mat-header-cell *matHeaderCellDef>File</th>
              <td style="max-width: 40px" mat-cell *matCellDef="let element">{{ element.fileNumber }}</td>
            </ng-container>

              
            <ng-container matColumnDef="dateRange" >
                <th mat-header-cell *matHeaderCellDef>Fecha File</th>
                <td style="max-width: 40px" mat-cell *matCellDef="let element">{{ element.fileDate }}</td>
              </ng-container>
  
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" ></tr>
  
          </table>
        </div>
        <div [hidden]="loading">
          <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                         showFirstLastButtons>
          </mat-paginator>
        </div>  
  
    </div>
  
  </div>
  
  
  
  
  